import FocusTrap from 'focus-trap-react';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { DropdownStateContext } from '../../Dropdown/DropdownStateManager';
import LoadingIndicator from '../../LoadingIndicator';
import PopoverCard from '../../Popup/_partials/PopoverCard';
import { useFriendList } from '../../utils/hooks/useFriendList';
import { useListKeyboardNavigation } from '../../utils/hooks/useListKeyboardNavigation';
import UserInput from '../_partials/UserInput';
import UserList from '../_partials/UserList';
import s from './DeviantsListCard.scss';
var DeviantsListCard = function (_a) {
    var selectedUserId = _a.selectedUserId, onItemClick = _a.onItemClick, onClose = _a.onClose;
    var _b = useState(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var closeDropdown = useContext(DropdownStateContext).closeDropdown;
    var _c = useFriendList(searchTerm), users = _c.users, streamId = _c.streamId, isLoading = _c.isLoading, isInitialized = _c.isInitialized;
    var onKeyboardItemSelected = useCallback(function (selectedIndex) {
        return onItemClick && users[selectedIndex] && onItemClick(users[selectedIndex]);
    }, [onItemClick, users]);
    var _d = useListKeyboardNavigation(users.length, onKeyboardItemSelected, onClose !== null && onClose !== void 0 ? onClose : closeDropdown), onKeyEvent = _d.onKeyEvent, selectedIndex = _d.selectedIndex, resetSelectedIndex = _d.resetSelectedIndex, selectFirstIndex = _d.selectFirstIndex;
    // Reset the selected index to nothing when our list is loading,
    // or to the first item if the user is actively searching.
    useEffect(function () {
        if (isLoading) {
            resetSelectedIndex();
        }
        else if (!isLoading && isInitialized && searchTerm.length >= 3) {
            selectFirstIndex();
        }
    }, [
        isLoading,
        isInitialized,
        resetSelectedIndex,
        searchTerm,
        selectFirstIndex,
    ]);
    // For use with aria-activedescendant
    var generateItemId = useCallback(function (index) { return "deviation-list-item-" + index; }, []);
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: 'deviantssearch' } },
        React.createElement(PopoverCard, { className: s['root'], withCloseButton: false },
            React.createElement(FocusTrap, { focusTrapOptions: { clickOutsideDeactivates: true } },
                React.createElement("div", { className: s['content'], onKeyDown: onKeyEvent, 
                    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
                    role: "combobox", "aria-haspopup": "listbox", "aria-expanded": "true" },
                    React.createElement(UserInput, { value: searchTerm, onChange: setSearchTerm, className: s['filter-input'], "aria-autocomplete": searchTerm.length >= 3 ? 'list' : 'none', "aria-activedescendant": selectedIndex !== undefined
                            ? generateItemId(selectedIndex)
                            : undefined, "aria-controls": "deviants-card-user-list" }),
                    isInitialized && (React.createElement(UserList, { id: "deviants-card-user-list", itemIdGenerator: generateItemId, streamId: streamId, users: users, className: s['list'], isLoading: isLoading, selectedUserId: selectedUserId, keyboardSelectedIndex: selectedIndex, onItemClick: onItemClick })),
                    !isInitialized && React.createElement(LoadingIndicator, null))))));
};
DeviantsListCard.displayName = 'DeviantsListCard';
export default DeviantsListCard;
//# sourceMappingURL=DeviantsListCard.js.map